export default "/img/KI.ac2810a291531bedc1a26901cb37ce89.png";